<template>
  <div>
    <base-card>
      <!-- v-show="modifierList != ''" -->
      <div>
        <v-card-title v-if="!cardLoading" class="mb-n7">
          <div class="d-flex justify-space-between flex-wrap">
            <v-btn
              class="ma-2"
              small
              dark
              color="primary"
              @click="(title = 'Add'), openDialog()"
            >
              <v-icon small>mdi-plus</v-icon>
              Add Modifier
            </v-btn>
            <div>
              <v-btn
                class="ma-2"
                small
                dark
                color="danger"
                v-if="selected != ''"
                @click="dialogDelete = true"
              >
                <v-icon small>mdi-delete</v-icon>
                delete
              </v-btn>
            </div>
          </div>
        </v-card-title>
        <v-card-title>
          <v-row>
            <v-col cols="12" lg="8">Modifier</v-col>
            <v-col cols="12" lg="4"
              ><v-text-field
                class="mt-n5"
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                v-if="!cardLoading"
              ></v-text-field
            ></v-col>
          </v-row>
        </v-card-title>

        <div class="text-center" v-if="cardLoading">
          <v-progress-circular
            class="mb-16"
            :size="40"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <div v-show="!cardLoading">
          <v-data-table
            v-model="selected"
            :search="search"
            :headers="headers"
            :items="modifierList"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            item-key="id"
            @click:row="handleClick"
            show-select
          >
            <template v-slot:item.name="{ item }">
              <span class="font-weight-bold">{{ item.name }}</span> <br />
              <span
                v-for="(mod, index) in item.item"
                :item="mod"
                :index="index"
                :key="mod.mod_item_id"
                >{{ mod.name
                }}<span v-if="index < item.item.length - 1">, </span>
              </span>
            </template>
          </v-data-table>
        </div>
      </div>
    </base-card>

    <v-dialog v-model="dialog" eager width="600">
      <base-card>
        <v-card-text>
          <v-form ref="form" class="ma-8" v-model="valid" lazy-validation>
            <div class="mb-5">
              <span class="text-h6">{{ title }} Modifier</span>
            </div>
            <v-text-field
              prepend-icon="mdi-alphabetical-variant"
              label="Modifier Group Name"
              v-model="mName"
              :rules="[(v) => !!v || 'Modifier group name is required']"
            ></v-text-field>
            <v-select
              v-model="selectBranch"
              :items="branchList"
              multiple
              chips
              prepend-icon="mdi-store"
              item-text="name"
              item-value="branch_id"
              label="Select Branch"
              :rules="[(v) => !!v.length > 0 || 'Branch is required']"
            >
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleForBranch">
                  <v-list-item-action>
                    <v-icon :color="selectBranch.length > 0 ? 'primary' : ''">
                      {{ iconForBranch }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title> Select All </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>

            <v-text-field
              prepend-icon="mdi-format-list-numbered"
              v-model="sequenceNumber"
              type="number"
              :rules="[
                (v) =>
                  /null|^(|\d)+$/.test(v) ||
                  'Sequence number must be a positive number not decimal',
              ]"
              label="Sequence Number (optional)"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>
                  Sequence of the modifier (Customer View)
                </v-tooltip>
              </template>
            </v-text-field>

            <draggable
              :list="list"
              item-key="mod_item_id"
              @change="onChange"
              class="mb-n1"
            >
              <v-list v-for="(element, idx) in list" :key="element.sequence">
                <v-row class="mb-n5">
                  <v-col cols="1"
                    ><v-icon class="row-pointer">mdi-menu</v-icon></v-col
                  >
                  <v-col cols="6">
                    <v-text-field
                      v-model="element.name"
                      class="mt-n4"
                      label="Option Name"
                      :rules="[(v) => !!v || 'Option name is required']"
                    ></v-text-field
                  ></v-col>
                  <v-col cols="3"
                    ><v-text-field
                      v-model="element.price"
                      label="Price"
                      class="mt-n4"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) => v >= 0 || 'Price should not be negative',
                      ]"
                      type="number"
                    ></v-text-field
                  ></v-col>

                  <v-col cols="1"
                    ><v-icon @click="removeAt(idx)">mdi-close</v-icon></v-col
                  >
                </v-row>
              </v-list>
            </draggable>
            <v-btn
              depressed
              class="ma-2 primary--text"
              color="lighten-5 primary"
              @click="add"
            >
              Add Option
            </v-btn>
            <v-row>
              <v-col cols="9">
                <v-text-field
                  v-model="minSelect"
                  :disabled="!switch1"
                  type="number"
                  :rules="
                    !switch1
                      ? [
                          (v) =>
                            (v !== null &&
                              v !== undefined &&
                              v !== '' &&
                              /^(|\d)+$/.test(v) &&
                              v <= list.length) ||
                            'This field is required , a positive whole number and not exceed modifier item number',
                        ]
                      : [
                          (v) =>
                            (v !== null &&
                              v !== undefined &&
                              v !== '' &&
                              /^[1-9]\d*$/.test(v) &&
                              v <= list.length) ||
                            'This field is required, a positive whole number greater than 0 and not exceed modifier item number',
                        ]
                  "
                  label="Set Mininimum Selection"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                      </template>
                      Set Limit on minimum how many item can be select on this
                      modifier.(Leave 0 if no limit)
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-switch
                  v-model="switch1"
                  :label="switch1 == true ? 'On' : 'Off'"
                ></v-switch>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="9">
                <v-text-field
                  v-model.number="maxSelect"
                  :disabled="!switch2"
                  type="number"
                  :rules="maxSelectRules"
                  label="Set Maximum Selection"
                >
                  <template v-slot:prepend>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                      </template>
                      Set Limit on maximum how many item can be select on this
                      modifier.(Leave 0 if no limit)
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="3">
                <v-switch
                  v-model="switch2"
                  :label="switch2 == true ? 'On' : 'Off'"
                ></v-switch>
              </v-col>
            </v-row>

            <v-select
              v-model="selectModifierDining"
              @change="setCompulsoryCheckBox()"
              :items="diningList"
              clearable
              chips
              prepend-icon="mdi-eye"
              item-text="name"
              item-value="dining_id"
              label="show only on (optional)"
            >
            </v-select>
            <v-checkbox
              :disabled="stackableCheckBox == '1'"
              v-model="compulsoryCheckBox"
              label="Compulsory Field"
              true-value="1"
              false-value="0"
            ></v-checkbox>
            <v-checkbox
              :disabled="compulsoryCheckBox == '1'"
              v-model="stackableCheckBox"
              label="Stackable"
              true-value="1"
              false-value="0"
            >
              <template v-slot:append>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on"> mdi-help-circle-outline </v-icon>
                  </template>
                  When stackable is enabled, the modifier can be added in
                  multiple quantities. When disabled, only one unit can be
                  added.
                </v-tooltip>
              </template>
            </v-checkbox>

            <v-select
              v-model="selectedSymbol"
              :items="symbols"
              label="Choose a symbol"
              prepend-icon="mdi-symbol"
            ></v-select>

            <v-autocomplete
              ref="productAutocomplete"
              v-model="selectedModLinkProduct"
              :items="groupedProducts"
              item-text="product_name"
              item-value="product_id"
              prepend-icon="mdi-tooltip-plus"
              return-object
              multiple
              clearable
              outlined
              dense
              :menu-props="{
                maxHeight: '300',
                contentClass: 'product-autocomplete-menu',
              }"
            >
              <!-- Field label with selected count -->
              <template v-slot:label>
                <span>Assign Product</span>
                <span
                  v-if="selectedModLinkProduct && selectedModLinkProduct.length"
                  style="margin-left: 6px; font-size: 11px; opacity: 0.7"
                >
                  ({{ selectedModLinkProduct.length }} selected)
                </span>
              </template>

              <!-- Selected chips — show first 2, collapse rest into "+N more" -->
              <template v-slot:selection="{ item, index }">
                <v-chip
                  v-if="index < 2 && item && item.product_name"
                  small
                  close
                  color="primary"
                  outlined
                  @click:close="removeSelected(index)"
                  class="ma-1"
                  style="height: 28px; font-size: 13px; max-width: 140px"
                >
                  <span
                    style="
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      max-width: 100px;
                    "
                  >
                    {{ item.product_name }}
                  </span>
                </v-chip>
                <span v-if="index === 2" class="caption grey--text">
                  +{{ selectedModLinkProduct.length - 2 }} more
                </span>
              </template>

              <!-- Grouped item rendering -->
              <template v-slot:item="{ item, on, attrs }">
                <!-- Category header row with extending divider -->
                <v-list-item
                  v-if="item.header"
                  :key="'header-' + item.header"
                  style="min-height: 28px; pointer-events: none"
                >
                  <span
                    style="
                      font-size: 10px;
                      font-weight: 600;
                      letter-spacing: 0.07em;
                      text-transform: uppercase;
                      color: #534ab7;
                      white-space: nowrap;
                      margin-right: 8px;
                    "
                  >
                    {{ item.header }}
                  </span>
                  <v-divider />
                </v-list-item>

                <!-- Product item with icon checkbox -->
                <v-list-item
                  v-else
                  v-bind="attrs"
                  v-on="on"
                  :key="'product-' + item.product_id"
                  dense
                >
                  <v-list-item-action style="margin-right: 8px">
                    <v-icon small :color="attrs.inputValue ? 'primary' : ''">
                      {{
                        attrs.inputValue
                          ? "mdi-checkbox-marked"
                          : "mdi-checkbox-blank-outline"
                      }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title style="font-size: 13px">
                      {{ item.product_name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <!-- Sticky footer: selected count + Done button -->
              <template v-slot:append-item>
                <div class="product-autocomplete-footer">
                  <v-divider />
                  <div
                    style="
                      padding: 8px 12px;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                    "
                  >
                    <span class="caption grey--text" style="flex: 1">
                      {{
                        selectedModLinkProduct
                          ? selectedModLinkProduct.length
                          : 0
                      }}
                      product(s) selected
                    </span>
                    <v-btn
                      small
                      color="primary"
                      @mousedown.prevent
                      @click="$refs.productAutocomplete.blur()"
                    >
                      Done
                    </v-btn>
                  </div>
                </div>
              </template>
            </v-autocomplete>

            <v-checkbox
              v-model="useIngredient"
              label="Ingredient "
              true-value="1"
              false-value="0"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="title == 'Edit'"
            @click="dialogDelete = true"
            text
            icon
            color="red lighten-2"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="btnLoading"
            @click="dialogAction()"
            text
          >
            save
          </v-btn>
        </v-card-actions>
      </base-card>
    </v-dialog>
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-subtitle-1"
          >Are you sure you want to delete this Modifier?<br />
          All the product will lose the modifier too.</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            :loading="deleteBtn"
            @click="deleteModifier"
            text
            >OK</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { BASEURL, BASESYNCURL } from "@/api/baseurl";
import axios from "axios";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      // ingredient
      useIngredient: "0",
      //
      compulsoryCheckBox: "0",
      stackableCheckBox: "0",
      diningList: [],
      domain: BASEURL,
      syncDomain: BASESYNCURL,
      snackbar: false,
      text: "",
      myArray: [],
      snackbarColor: "",
      timeout: 1900,
      companyID: "",
      headers: [
        {
          text: "Modifier Name",
          align: "start",
          sortable: true,
          value: "name",
        },
      ],
      delete: false,
      deleteBtn: false,
      modifierList: [],
      dialog: false,
      title: "",
      switch1: false,
      switch2: false,
      mName: "",
      valid: "",
      list: [{ name: "", price: "0.00", sequence: 1, mod_item_id: 0 }],
      selectBranch: [],
      branchList: [],
      modLinkProductList: [],
      selectedModLinkProduct: [],
      btnLoading: false,
      selectModifier: "",
      selectModifierDining: "",
      sequenceNumber: "",
      minSelect: 0,
      maxSelect: 0,
      cardLoading: true,
      selectedSymbol: "+",
      symbols: ["+", "-", "x", "*"], // only 4 symbols
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialogDelete: false,
      search: "",
      selected: [],
      color: "#E0E0E0",
      swatches: [
        "#E0E0E0",
        "#F44366",
        "#E91E63",
        "#FF9800",
        "#CDDC39",
        "#4CAF50",
        "#2196F3",
        "#9C27B0",
      ],
    };
  },

  computed: {
    maxSelectRules() {
      return [
        (v) => {
          if (!this.switch2) {
            // When switch OFF → allow only 0
            return v === 0 || "When disabled, value must be 0";
          }

          if (v === null || v === undefined || v === "") {
            return "This field is required";
          }

          // Must be positive integer
          if (!/^[1-9]\d*$/.test(v)) {
            return "Must be a positive whole number greater than 0";
          }

          // 🚀 If stackable is ticked → no max limit
          if (this.stackableCheckBox === "1") {
            return true;
          }

          // Normal case → cannot exceed modifier item count
          if (Number(v) > this.list.length) {
            return `Cannot exceed modifier item number (${this.list.length})`;
          }

          return true;
        },
      ];
    },
    getAllBranchID() {
      var array = [];
      for (let i = 0; i < this.branchList.length; i++) {
        array.push(this.branchList[i].branch_id);
      }
      return array;
    },

    selectAllBranch() {
      return this.selectBranch.length === this.getAllBranchID.length;
    },

    selectSomeBranch() {
      return this.selectBranch.length > 0 && !this.selectAllBranch;
    },

    iconForBranch() {
      if (this.selectAllBranch) return "mdi-close-box";
      if (this.selectSomeBranch) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    groupedProducts() {
      const grouped = [];
      const addedCategories = new Set();

      const sorted = [...this.modLinkProductList].sort((a, b) =>
        a.category_name.localeCompare(b.category_name)
      );

      sorted.forEach((item) => {
        if (!addedCategories.has(item.category_name)) {
          grouped.push({ header: item.category_name });
          addedCategories.add(item.category_name);
        }
        grouped.push(item);
      });

      return grouped;
    },
  },

  watch: {
    switch1() {
      if (this.switch1) {
        if (this.minSelect === 0) {
          this.minSelect = 1;
        }
      } else if (!this.switch1) {
        this.minSelect = 0;
      }
    },

    switch2() {
      if (this.switch2) {
        if (this.maxSelect === 0) {
          this.maxSelect = 1;
        }
      } else if (!this.switch2) {
        this.maxSelect = 0;
      }
    },

    compulsoryCheckBox() {
      if (this.compulsoryCheckBox == "1") {
        this.stackableCheckBox == "0";
      }
    },
    stackableCheckBox() {
      if (this.stackableCheckBox == "1") {
        this.compulsoryCheckBox == "0";
      }
    },
  },

  created() {
    var CryptoJS = require("crypto-js");
    var x = localStorage.getItem("userInfo");
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(x, "secret key 123");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.companyID = decryptedData.company_id;
    this.getAllModifier();
    this.getAllDiningOption();
    this.getModLinkProduct();
  },

  methods: {
    removeSelected(index) {
      this.selectedModLinkProduct.splice(index, 1);
    },
    onChange(event) {
      this.reorder();
    },
    reorder() {
      this.list.forEach((item, index) => (item.sequence = index + 1));
    },

    removeAt(idx) {
      if (this.list.length == 1) {
        this.text = "At least one option for Modifier";
        this.snackbar = true;
        this.snackbarColor = "warning";
      } else {
        this.list.splice(idx, 1);
      }
    },
    add: function () {
      if (this.$refs.form.validate()) {
        var sequence = this.list.length;
        sequence = sequence + 1;
        this.list.push({
          name: "",
          price: "0.00",
          sequence: sequence,
          mod_item_id: 0,
        });
      }
    },

    setCompulsoryCheckBox() {
      if (this.selectModifierDining != "") {
        this.compulsoryCheckBox = "1";
      } else {
        this.compulsoryCheckBox = "0";
      }
    },

    getAllDiningOption() {
      const params = new URLSearchParams();
      params.append("getAllDiningOption", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/dining/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.diningList = response.data.dining;
          } else {
            console.log("no list get");
            this.diningList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompanyBranch() {
      const params = new URLSearchParams();
      params.append("getCompanyBranch", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.branchList = response.data.branch;
          } else {
            this.branchList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toggleForBranch() {
      this.$nextTick(() => {
        if (this.selectAllBranch) {
          this.selectBranch = [];
        } else {
          this.selectBranch = this.getAllBranchID.slice();
        }
      });
    },

    sendNotication(branch_id) {
      const params = new URLSearchParams();
      params.append("send_notification", "done");
      params.append("branch_id", branch_id);
      params.append("type", "1");

      axios({
        method: "post",
        url: this.syncDomain + "/sync/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            console.log("Send Notification successfully");
          } else {
            console.log("Send Notification fail");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAllModifier() {
      const params = new URLSearchParams();
      params.append("getAllModifier", "done");
      params.append("company_id", this.companyID);

      axios({
        method: "post",
        url: this.domain + "/modifier/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.modifierList = response.data.modifier;
            this.cardLoading = false;
            if (this.title == "Add" && !this.delete) {
              this.text = "Successfully add";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.dialog = false;
              this.btnLoading = false;
            } else if (this.title == "Edit" && !this.delete) {
              this.text = "Successfully edit";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.dialog = false;
              this.btnLoading = false;
            }

            if (this.delete && this.selected == "") {
              this.dialog = false;
              this.text = "Successfully delete";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.dialogDelete = false;
              this.delete = false;
              this.deleteBtn = false;
            } else if (this.delete && this.selected != "") {
              this.dialog = false;
              this.text = "Successfully delete";
              this.snackbar = true;
              this.snackbarColor = "success";
              this.selected = [];
              this.dialogDelete = false;
              this.delete = false;
              this.deleteBtn = false;
            }
          } else {
            this.modifierList = [];
            this.cardLoading = false;
            this.dialog = false;
            this.btnLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openDialog() {
      this.getCompanyBranch();
      if (this.title == "Add") {
        this.dialog = true;
        this.list = [{ name: "", price: "", sequence: 1, mod_item_id: 0 }];
        this.selectedModLinkProduct = [];
        process.nextTick(() => {
          this.$refs.form.resetValidation();
          this.mName = "";
          this.selectBranch = [];
          this.sequenceNumber = "";
          this.selectModifierDining = "";
          this.compulsoryCheckBox = "0";
          this.stackableCheckBox = "0";
          this.useIngredient = "0";
          this.switch1 = false;
          this.switch2 = false;
          this.selectedSymbol = "+";
        });
      } else {
        this.dialog = true;
      }
    },

    handleClick(item) {
      this.title = "Edit";
      var array = [];
      this.getCurrentModLinkProduct(item.id);
      this.mName = item.name;
      for (let i = 0; i < item.branch.length; i++) {
        array.push(parseInt(item.branch[i].id));
      }

      this.switch1 = item.min_select > 0 ? true : false;

      this.minSelect = item.min_select;

      this.switch2 = item.max_select > 0 ? true : false;

      this.maxSelect = item.max_select;
      this.useIngredient = item.use_ingredient.toString();

      this.selectBranch = array;
      this.list = item.item;
      this.sequenceNumber = item.sequence_number;
      this.selectModifier = item.id;
      this.selectModifierDining = parseInt(item.dining_id);
      this.compulsoryCheckBox = item.compulsory;
      this.stackableCheckBox = item.stackable.toString();
      this.selectedSymbol = item.symbol;
      this.openDialog();
    },

    getBranchForNotification(mod_group_id) {
      const params = new URLSearchParams();
      params.append("getModifierBranch", "done");
      params.append("mod_group_id", mod_group_id);
      axios({
        method: "post",
        url: this.domain + "/modifier/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            var branchList = response.data.modifier;
            for (let i = 0; i < branchList.length; i++) {
              this.sendNotication(branchList[i].id);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getModLinkProduct() {
      const params = new URLSearchParams();
      params.append("getModLinkProduct", "done");
      params.append("company_id", this.companyID);
      axios({
        method: "post",
        url: this.domain + "/modifier/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.modLinkProductList = response.data.modifier;
          } else {
            this.modLinkProductList = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCurrentModLinkProduct(mod_group_id) {
      const params = new URLSearchParams();
      params.append("getCurrentModLinkProduct", "done");
      params.append("company_id", this.companyID);
      params.append("mod_group_id", mod_group_id);
      axios({
        method: "post",
        url: this.domain + "/modifier/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.selectedModLinkProduct = response.data.modifier;
          } else {
            this.selectedModLinkProduct = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    deleteModifier() {
      if (this.selected != "") {
        const array = [];
        for (let i = 0; i < this.selected.length; i++) {
          array.push(this.selected[i].id);
        }
        const params = new URLSearchParams();
        params.append("deleteMultiMod", "done");
        params.append("array_mod_group_id", JSON.stringify(array));
        axios({
          method: "post",
          url: this.domain + "/modifier/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.delete = true;
              this.deleteBtn = true;
              this.getAllModifier();
              for (let j = 0; j < array.length; j++) {
                this.getBranchForNotification(array[j]);
              }
            } else {
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
              this.deleteBtn = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const params = new URLSearchParams();
        params.append("delete", "done");
        params.append("mod_group_id", this.selectModifier);
        axios({
          method: "post",
          url: this.domain + "/modifier/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.delete = true;
              this.deleteBtn = true;
              this.getAllModifier();
              this.getBranchForNotification(this.selectModifier);
            } else {
              this.text = "Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
              this.deleteBtn = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    dialogAction() {
      this.btnLoading = true;
      if (this.title == "Add") {
        if (this.$refs.form.validate()) {
          const params = new URLSearchParams();
          params.append("addModifierSpecialTestWithIngredient", "done");
          params.append("company_id", this.companyID);
          params.append("name", this.mName);
          params.append("minSelect", this.minSelect);
          params.append("maxSelect", this.maxSelect);
          params.append(
            "sequence_number",
            this.sequenceNumber == null ? "" : this.sequenceNumber
          );
          params.append("branch_array_list", JSON.stringify(this.selectBranch));
          params.append("list", JSON.stringify(this.list));
          params.append(
            "dining_id",
            this.selectModifierDining ? this.selectModifierDining : ""
          );
          params.append("compulsory", this.compulsoryCheckBox);

          params.append("stackable", this.stackableCheckBox);

          params.append("symbol", this.selectedSymbol);

          params.append(
            "modLinkProduct",
            JSON.stringify(this.selectedModLinkProduct)
          );

          params.append("use_ingredient", this.useIngredient);

          axios({
            method: "post",
            url: this.domain + "/modifier/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.getAllModifier();
                for (let i = 0; i < this.selectBranch.length; i++) {
                  this.sendNotication(this.selectBranch[i]);
                }
              } else {
                this.btnLoading = false;
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.btnLoading = false;
          this.text = "Please make sure mandatory field is fill in correctly";
          this.snackbar = true;
          this.snackbarColor = "error";
        }
      } else {
        if (this.$refs.form.validate()) {
          console.log(this.selectedModLinkProduct);
          const params = new URLSearchParams();
          params.append("editModifierSpecialTestWithIngredient", "done");
          params.append("name", this.mName);
          params.append("minSelect", this.minSelect);
          params.append("maxSelect", this.maxSelect);
          params.append("id", this.selectModifier);
          params.append(
            "sequence_number",
            this.sequenceNumber == null ? "" : this.sequenceNumber
          );
          params.append("branch_array_list", JSON.stringify(this.selectBranch));
          params.append("list", JSON.stringify(this.list));
          params.append(
            "dining_id",
            this.selectModifierDining ? this.selectModifierDining : ""
          );

          params.append("compulsory", this.compulsoryCheckBox);

          params.append("stackable", this.stackableCheckBox);

          params.append("symbol", this.selectedSymbol);

          params.append(
            "modLinkProduct",
            JSON.stringify(this.selectedModLinkProduct)
          );

          params.append("use_ingredient", this.useIngredient);

          axios({
            method: "post",
            url: this.domain + "/modifier/index.php",
            data: params,
          })
            .then((response) => {
              console.log(response);
              if (response.data.status == "1") {
                this.getAllModifier();
                for (let i = 0; i < this.selectBranch.length; i++) {
                  this.sendNotication(this.selectBranch[i]);
                }
              } else {
                this.btnLoading = false;
                this.text = "Please try again later";
                this.snackbar = true;
                this.snackbarColor = "error";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.btnLoading = false;
          this.text = "Please make sure mandatory field is fill in correctly";
          this.snackbar = true;
          this.snackbarColor = "error";
        }
      }
    },
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
.row-pointer {
  cursor: pointer;
}

::v-deep .product-autocomplete-menu {
  background: #ffffff !important;
}

::v-deep .product-autocomplete-menu .v-select-list {
  background: #ffffff !important;
  display: flex;
  flex-direction: column;
  max-height: 300px;
}

::v-deep .product-autocomplete-menu .v-select-list .v-list {
  flex: 1;
  overflow-y: auto;
  background: #ffffff !important;
}

.product-autocomplete-footer {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background: #ffffff !important;
  box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.08);
}
</style>

<style scoped>
.group-header {
  pointer-events: none;
  font-weight: bold;
  color: #555;
}
</style>